export class AccountListItem {
    id?: number;
    transaction_entity_name?: string;
    transaction_entity_description?: string;
    transaction_entity_category?: string;
    transaction_entity_type?: string;
    transaction_entity_past_tense?: string;
    is_exclusive?: number;
    transaction_entity_balance_amount?: number;
    transaction_entity_balance_type?: string;
    transaction_entity_balance_quantity?: number;

    constructor(init?: Partial<AccountListItem>) {
        Object.assign(this, init);
    }
}